import { render, staticRenderFns } from "./SettingsMapping.vue?vue&type=template&id=beb309c0&scoped=true&"
import script from "./SettingsMapping.vue?vue&type=script&lang=ts&"
export * from "./SettingsMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb309c0",
  null
  
)

export default component.exports